import Swal from "sweetalert2";

async function downloadFile(format: 'pdf' | 'excel', marca: any, axios: any, apiRoute: any, items: any, templateId: string | null) {
    try {
        const token = localStorage.getItem('authToken');

        const headers = {
            Authorization: `Bearer ${token}`,
        };

        const data: any = {
            items,
            marca
        }

        if (templateId) {
            data.template_id = templateId;
        }

        const endpoint = format === 'excel' ? '/pedido/generate-order-excel' : '/pedido/generate-order-pdf';

        const response = await axios.post(apiRoute + endpoint, data, {
            headers: headers,
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        let filename = ``;

        if (marca === "") {
            filename = `PEDIDO_MAESTRO_${Date.now().toString()}`;
        } else {
            const id = items.find((item: any) => item.marca === marca)?.id;
            if (id) {
                filename = `PEDIDO_${marca}_${id}_${Date.now().toString()}`;
            }
        }
        const ext = format === 'excel' ? '.xlsx' : '.pdf';
        link.setAttribute('download', filename + ext);
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error(error);
    }
}

async function fetchAvailableTemplates(axios: any, apiRoute: any, format: 'pdf' | 'excel'): Promise<any[]> {
    try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get(`${apiRoute}/pedido/export-templates/available`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { format },
        });
        return response.data?.data ?? [];
    } catch (error) {
        // si falla la carga de plantillas, se sigue con el flujo normal (sin selector)
        return [];
    }
}

function renderTemplateOptions(templates: any[]): string {
    if (templates.length === 0) return '';

    let html = `
    <select id="template_id" class="swal2-input p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500">
    <option value="">Formato original (sin plantilla)</option>
    `;
    templates.forEach((t: any) => {
        html += `<option value="${t.id}" ${t.is_default ? 'selected' : ''}>${t.name}</option>`;
    });
    html += `</select>`;
    return html;
}

export default async function openDownloadModal(marcas: any, axios: any, apiRoute: any, data: any) {
    const LastBranchSelected: string | null = localStorage.getItem('LastBranchSelected');

    let marcaOptions = `<option value="">PEDIDO COMPLETO</option>`;
    marcas.forEach((element: any) => {
        marcaOptions += `<option value="${element}"  ${element === LastBranchSelected ? 'selected' : ''}>${element}</option>`;
    });

    const [pdfTemplates, excelTemplates] = await Promise.all([
        fetchAvailableTemplates(axios, apiRoute, 'pdf'),
        fetchAvailableTemplates(axios, apiRoute, 'excel'),
    ]);

    const html = `
    <div class="text-left text-sm">
        <label class="block text-sm font-semibold text-gray-700 mb-1.5">Marca</label>
        <select id="marca" class="swal2-input p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-blue-200 focus:border-blue-500 w-full m-0 mb-3">
            ${marcaOptions}
        </select>

        <label class="block text-sm font-semibold text-gray-700 mb-1.5">Formato</label>
        <div class="flex gap-3 mb-3">
            <label id="format_pdf_label" class="flex-1 flex items-center gap-2 border border-blue-500 bg-blue-50 rounded-lg px-3 py-2.5 cursor-pointer hover:bg-gray-50">
                <input type="radio" name="download_format" id="format_pdf" value="pdf" checked class="text-blue-600" />
                <span class="text-sm text-gray-700">PDF</span>
            </label>
            <label id="format_excel_label" class="flex-1 flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2.5 cursor-pointer hover:bg-gray-50">
                <input type="radio" name="download_format" id="format_excel" value="excel" class="text-blue-600" />
                <span class="text-sm text-gray-700">Excel</span>
            </label>
        </div>

        <div id="template_wrapper_pdf">${renderTemplateOptions(pdfTemplates)}</div>
        <div id="template_wrapper_excel" class="hidden">${renderTemplateOptions(excelTemplates)}</div>
    </div>
    `;

    Swal.fire({
        title: 'Descargar Pedido',
        html,
        showCancelButton: true,
        confirmButtonText: 'Descargar',
        reverseButtons: true,
        focusConfirm: false,
        customClass: {
            confirmButton: 'custom-confirm-button'
        },
        didOpen: () => {
            const pdfRadio = document.getElementById('format_pdf') as HTMLInputElement;
            const excelRadio = document.getElementById('format_excel') as HTMLInputElement;
            const pdfLabel = document.getElementById('format_pdf_label') as HTMLLabelElement;
            const excelLabel = document.getElementById('format_excel_label') as HTMLLabelElement;
            const pdfWrapper = document.getElementById('template_wrapper_pdf') as HTMLDivElement;
            const excelWrapper = document.getElementById('template_wrapper_excel') as HTMLDivElement;

            const sync = () => {
                const isExcel = excelRadio.checked;
                pdfWrapper.classList.toggle('hidden', isExcel);
                excelWrapper.classList.toggle('hidden', !isExcel);
                pdfLabel.classList.toggle('border-blue-500', !isExcel);
                pdfLabel.classList.toggle('bg-blue-50', !isExcel);
                pdfLabel.classList.toggle('border-gray-300', isExcel);
                excelLabel.classList.toggle('border-blue-500', isExcel);
                excelLabel.classList.toggle('bg-blue-50', isExcel);
                excelLabel.classList.toggle('border-gray-300', !isExcel);
            };

            pdfRadio.addEventListener('change', sync);
            excelRadio.addEventListener('change', sync);
        },
        preConfirm: () => {
            const marcaElement = document.getElementById('marca') as HTMLInputElement;
            const formatElement = document.querySelector('input[name="download_format"]:checked') as HTMLInputElement | null;
            const format = (formatElement?.value === 'excel' ? 'excel' : 'pdf') as 'pdf' | 'excel';
            const templateElement = document.querySelector(`#template_wrapper_${format} select`) as HTMLSelectElement | null;

            if (marcaElement) {
                const marca: any = marcaElement.value;
                const templateId = templateElement ? templateElement.value : null;
                downloadFile(format, marca, axios, apiRoute, data, templateId);
            }
        },
    });
}
